export default __webpack_public_path__ + "static/media/5_logo.63aade78.png";